import React from 'react';
import { withRouter } from 'react-router-dom';
import { user_token } from '../helpers/Global';
import { api_route, user_logout } from '../helpers/Global';
import queryString from 'query-string';

class Resume extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            infolivreur: [],
            time_param: '',
            refresh_data: 'init',
        }
    }
    
    componentDidMount() {
        if (!user_token()) {
            this.props.history.push(`/user-logout`);
        }
        this.componentDidUpdate();
    }
    
     componentDidUpdate() {
        var params = queryString.parse(this.props.location.search);
        var time_param = params.t;
        
         if (this.state.time_param !== time_param || this.state.refresh_data) {
            fetch(api_route('info-livreur'), { method: 'GET' })
                .then(resp => resp.json())
                .then(resp => {
                    if (resp.response === 'error-connected') {
                        user_logout();
                        this.props.history.push(`/user-logout`);
                        this.props.loaderDisplay(false);
                    } else if (resp['info-general']) {
                        var livreur = resp['info-general'];
                        this.setState({
                            infolivreur: livreur
                        });
                    }
                })
               .catch(err => {
                    this.props.loaderDisplay(false);
                    this.props.openErrorSystem(true);
                })
            
            this.setState({
                time_param: time_param,
                refresh_data: false,
            });
        }
    }

    render() {
        //var livreur = this.props.livreur;
        var livreur = this.state.infolivreur;
        return (
            <React.Fragment>

                <div className="row">
                    <div className="banner gradient-template col-12 mb-4 pb-5">
                        <h2 className="text-center my-5 font-weight-light">Votre Situation Financière</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="container top-60">
                        <div className="row">

                            <div className="col-12 col-md-6 ">
                                <div className="card border-0 shadow-sm mb-4">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col">
                                                <h6 className="mb-0"><span className="subtitle">Total livraison</span></h6>
                                                <h3 className="font-weight-normal text-danger mt-2">{livreur.livreur_total_brute} Dhs</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-md-6 ">
                                <div className="card border-0 shadow-sm mb-4">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col">
                                                <h6 className="mb-0"><span className="subtitle">Ma commission</span></h6>
                                                <h3 className="font-weight-normal text-warning mt-2">{livreur.livreur_total_comission} Dhs</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-md-6 ">
                                <div className="card border-0 shadow-sm mb-4">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col">
                                                <h6 className="mb-0"><span className="subtitle">Total à verser</span></h6>
                                                <h3 className="font-weight-normal text-success mt-2">{livreur.livreur_total_credit} Dhs</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>

            </React.Fragment>
        );
    }

}

export default withRouter(Resume);